/*
 * @Author: your name
 * @Date: 2021-06-30 10:59:21
 * @LastEditTime: 2022-11-30 16:31:51
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\utils\globalData.js
 */
import VueCookies from "vue-cookies";
// import  store from '../store/index'
import { epecGrayGroup } from "../api/config";

/* 
  const companyId = JSON.parse(window.localStorage.getItem("USERINFO")).companyId;
  console.log(companyId, 'window.localStorage.getItem("USERINFO")');

*/
const companyId = JSON.parse(window.localStorage.getItem("USERINFO")).companyId;
// let companyId = VueCookies.get("userInfo").companyId;
let epecTokenObj = {
  "epec-sso-token": VueCookies.get("epecToken"),
  "epec-from": "CORP_WEB_SITE",
  "epec-locale": "ZH",
  "epec-company-id": companyId,
};
if (process.env.NODE_ENV !== "production") {
  epecTokenObj["epec-gray-group"] = epecGrayGroup;
}

export let epecToken = epecTokenObj;

// 销售商城状态  101：待提交 102：申请中 103：生效中 104：变更中 105：审批拒绝'
export const mallTypeList = [
  {
    name: "已保存",
    key: 101,
  },
  {
    name: "待审核",
    key: 102,
  },
  {
    name: "生效中",
    key: 103,
  },
  {
    name: "待审核",
    key: 104,
  },
  {
    name: "审批拒绝",
    key: 105,
  },
  {
    name: "已停用",
    key: 106,
  },
];

export const templateStatusList = [
  {
    name: "已保存",
    key: 1,
  },
  {
    name: "待审核",
    key: 2,
  },
  {
    name: "审核通过待发布",
    key: 3,
  },
  {
    name: "审核拒绝",
    key: 4,
  },
  {
    name: "已发布",
    key: 5,
  },
  {
    name: "变更保存中",
    key: 6,
  },
  {
    name: "变更审核中",
    key: 7,
  },
];

// export const YPKphone = "400-819-8786";
export const YPKphone = "";
export const YPKcall = "95388-5";

//易派客平台销售唯一授权证明
export const CertificateOfAuthorization =
  "https://uatd-epec.oss-cn-beijing.aliyuncs.com/staticFiles/%E5%93%81%E7%89%8C%E6%8E%88%E6%9D%83%E8%AF%81%E6%98%8E.docx";

// 中文站
export const siteList = [
  {
    authName: "中文站",
    imgPath: require("../../../assets/img/national/guoqi.png"),
    authCode: "",
    childList: [
      {
        authName: "English",
        imgPath: require("../../../assets/img/national/england.png"),
        authCode: "https://uat-global.epec.com/portal/",
      },
      {
        authName: "Русский",
        imgPath: require("../../../assets/img/national/russin.png"),
        authCode: "https://uat-ru.epec.com/portal/",
      },
      {
        authName: "Español",
        imgPath: require("../../../assets/img/national/spain.png"),
        authCode: "https://uat-es.epec.com/portal/",
      },
    ],
  },
];

// 联系客服
export const servicePhoneData = [
  {
    authName: "联系客服",
    authCode: "",
    childList: [
      {
        authName: "95388-5",
        authCode: "",
      },
    ],
  },
];
